import { Component, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UsersService } from 'app/feature-modules/users/services/users.service';
import { ToastComponent } from '../toast/toast.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import * as FileSaver from 'file-saver';
import { LoadingComponent } from '../loading/loading.component';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-org-upload-dlg',
  templateUrl: './org-upload-dlg.component.html',
  styleUrls: ['./org-upload-dlg.component.scss'],
})
export class OrgUploadDlgComponent {
  selectedFile: File | null = null;
  private http = inject(HttpClient);
  private userSvc = inject(UsersService);
  public toast = inject(ToastComponent);
  public dialog = inject(MatDialog);
  public data = inject<{ uploadTypeString: string }>(MAT_DIALOG_DATA);
  isFileTypeNotAccepted = false;

  onCancel() {
    this.dialog.closeAll();
  }

  onProcessFile() {
    if (this.selectedFile != null) {
      const loadingDialogRef = this.dialog.open(LoadingComponent, {
        disableClose: true,
        data: { condition: true },
      });
      const formData = new FormData();
      formData.append('file', this.selectedFile, this.selectedFile.name);
      if (this.data.uploadTypeString === 'serviceProvider') {
        return this.userSvc.uploadServiceProvider(formData).subscribe(
          (response: { response: string }) => {
            loadingDialogRef.close();
            console.log('response', response.response);
            const blob = new Blob([response.response], { type: 'text/csv' });
            FileSaver.saveAs(blob, 'service-provider-import-results.csv');
            this.dialog.closeAll();
            this.toast.setMessage(
              `Uploaded successfully : ${this.selectedFile?.name} `,
              'success'
            );
          },
          (error) => {
            // Error callback
            loadingDialogRef.close();
            console.error('Error occurred:', error);
            this.toast.setMessage(
              `An error occurred while uploading the file : ${this.selectedFile?.name}`,
              'danger'
            );
          }
        );
      } else {
        return this.userSvc.uploadBuySideOrganization(formData).subscribe(
          (response: { response: string }) => {
            loadingDialogRef.close();
            console.log('response', response.response);
            const blob = new Blob([response.response], { type: 'text/csv' });
            FileSaver.saveAs(blob, 'buy-side-import-results.csv');
            this.dialog.closeAll();
            this.toast.setMessage(
              `Uploaded successfully: ${this.selectedFile?.name} `,
              'success'
            );
          },
          (error) => {
            // Error callback
            loadingDialogRef.close();
            console.error('Error occurred:', error);
            this.toast.setMessage(
              `An error occurred while uploading the file: ${this.selectedFile?.name}`,
              'danger'
            );
          }
        );
      }
    }
  }

  onFileSelected($event: Event) {
    console.log('onFileSelected', $event);
    const input = $event.target as HTMLInputElement;
    this.selectedFile = input.files && input.files.length > 0 ? input.files[0] : null;
    const selectedFileExtension = this.selectedFile?.name?.split('.').pop()?.toLowerCase() ?? '';
    if (this.selectedFile?.type !== 'text/csv' && selectedFileExtension !== 'csv') {
      this.isFileTypeNotAccepted = true;
      this.toast.setMessage(
        `Incorrect file type. Please select csv file only.: ${this.selectedFile?.name} `,
        'danger'
      );
    } else {
      this.isFileTypeNotAccepted = false;
    }
  }
}
